import { api } from ".";

const basePath = "/role";

export const createRole = async ({
  name,
  description,
  requiredSkills,
}: any) => {
  try {
    const res = await api.post(`${basePath}`, {
      name,
      description,
      requiredSkills,
    });
    return res;
  } catch (error) {
    return error;
  }
};

export const updateRoleById = async ({ id, updates }: any) => {
  try {
    const res = await api.put(`${basePath}`, {
      _id: id,
      ...updates,
    });
    return res;
  } catch (error) {
    console.error("Error updating user:", error);
    return error;
  }
};

export const getRoleList = async (params: Record<string, any> = {}) => {
  try {
    const filteredParams = Object.fromEntries(
      Object.entries(params).filter(([_, value]) => value !== undefined)
    );
    const res = await api.get(`${basePath}/list`, { params: filteredParams });
    return res;
  } catch (error) {
    return error;
  }
};

export const deleteRole = async ({ id }: { id: string }) => {
  try {
    const res = await api.delete(`${basePath}`, {
      data: { _id: id },
    });
    return res;
  } catch (error) {
    return error;
  }
};

export const getRoleSelectData = async () => {
  try {
    const res = await api.get(`${basePath}/select-data`);
    return res;
  } catch (error) {
    return error;
  }
};
